const stats = [
  { value: '500+', label: 'Installazioni completate', icon: 'ri-tools-fill' },
  { value: '15+', label: 'Anni di esperienza', icon: 'ri-calendar-fill' },
  { value: '4.5★', label: 'Valutazione media', icon: 'ri-star-fill' },
  { value: '24/7', label: 'Assistenza continua', icon: 'ri-time-fill' },
];

const features = [
  { icon: 'ri-shield-check-fill', text: 'Tecnici certificati e assicurati' },
  { icon: 'ri-award-fill', text: 'Garanzia su tutti i lavori eseguiti' },
  { icon: 'ri-map-pin-2-fill', text: 'Operativi su Ravenna e provincia' },
  { icon: 'ri-leaf-fill', text: 'Soluzioni ecologiche ed efficienti' },
];

export default function ChiSiamo() {
  return (
    <section id="chi-siamo" className="py-20 md:py-28 bg-[#FFF8F0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">

          {/* Left Column */}
          <div className="w-full lg:w-1/2">
            <span className="text-xs font-bold uppercase tracking-widest text-orange-600 mb-3 block">
              La Nostra Storia
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              Passione per il calore,<br />
              <span className="text-orange-500">esperienza nel servizio</span>
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6">
              Da oltre 15 anni serviamo famiglie e aziende a Ravenna con soluzioni di riscaldamento 
              efficienti ed ecologiche. Il nostro team certificato garantisce installazioni a norma 
              e manutenzioni preventive per massimizzare le prestazioni della tua stufa a pellet.
            </p>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
              Siamo disponibili 24 ore su 24, 7 giorni su 7, perché sappiamo che il calore non 
              può aspettare. La tua soddisfazione è la nostra priorità assoluta.
            </p>

            {/* Feature List */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {features.map((f) => (
                <div key={f.text} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-lg flex-shrink-0">
                    <i className={`${f.icon} text-orange-500 text-base`}></i>
                  </div>
                  <span className="text-gray-700 text-sm font-medium">{f.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="w-full lg:w-1/2">
            {/* Image */}
            <div className="relative mb-8 rounded-2xl overflow-hidden w-full h-64 md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20heating%20technician%20in%20work%20uniform%20installing%20a%20modern%20pellet%20stove%20in%20Italian%20home%20interior%2C%20competent%20and%20trustworthy%20worker%20smiling%2C%20tools%20in%20hand%2C%20warm%20natural%20lighting%2C%20clean%20and%20professional%20environment%2C%20high%20quality%20photorealistic%20image%2C%20warm%20tones%20orange%20and%20cream&width=800&height=500&seq=chisiamo001&orientation=landscape"
                alt="Tecnico specializzato nell'installazione stufe a pellet a Ravenna"
                className="w-full h-full object-cover object-top"
              />
              {/* Badge overlay */}
              <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-3 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-lg">
                  <i className="ri-verified-badge-fill text-white text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Certificati</p>
                  <p className="text-sm font-bold text-gray-900">Tecnici autorizzati</p>
                </div>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="bg-white rounded-xl p-5 border border-orange-50 transition-transform hover:-translate-y-1"
                >
                  <div className="w-9 h-9 flex items-center justify-center bg-orange-100 rounded-lg mb-3">
                    <i className={`${s.icon} text-orange-500 text-lg`}></i>
                  </div>
                  <p className="text-2xl md:text-3xl font-extrabold text-orange-500 mb-1">{s.value}</p>
                  <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
